import React from "react";
import { Helmet } from "react-helmet-async";
const SchemaComponent = () => {
  const schemaData2 = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What is composite bonding, and how does it work?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Composite bonding is a cosmetic dental treatment that uses a tooth-coloured resin material to repair chips, cracks, gaps, or discolouration and enhance the appearance of teeth. The resin is applied, shaped, and hardened with a special light, resulting in a natural-looking finish.",
        },
      },
      {
        "@type": "Question",
        name: "How long does composite bonding last?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "With proper care, composite bonding can last between 5 and 10 years. Its durability depends on factors such as oral hygiene, diet, and habits like teeth grinding or biting on hard objects.",
        },
      },
      {
        "@type": "Question",
        name: "Is composite bonding painful?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Composite bonding is typically a painless procedure and often does not require anaesthetic. The tooth surface is lightly prepared, and the resin is applied without causing discomfort.",
        },
      },
      {
        "@type": "Question",
        name: "Can composite bonding close gaps between teeth?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, composite bonding is an effective way to close small gaps between teeth. It can improve the appearance of your smile without the need for orthodontic treatment.",
        },
      },
      {
        "@type": "Question",
        name: "How should I care for my teeth after composite bonding?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "To maintain your composite bonding, practice good oral hygiene, avoid staining foods and drinks like tea, coffee, and red wine, and refrain from biting hard objects. Regular dental check-ups and cleanings are also important.",
        },
      },
      {
        "@type": "Question",
        name: "Who is a good candidate for composite bonding?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Composite bonding is ideal for people with minor cosmetic concerns, such as chipped, discoloured, or uneven teeth. However, it may not be suitable for those with significant dental issues or underlying oral health problems. A consultation with your dentist can help determine if it's the right treatment for you.",
        },
      },
      {
        "@type": "Question",
        name: "Who can benefit from composite bonding?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Anyone who has any slight imperfections with the size, shape or colour of their teeth can get a lovely new smile using composite bonding.",
        },
      },
      {
        "@type": "Question",
        name: "How much does composite bonding cost?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Composite bonding costs as little as £350 per tooth but we always suggest coming in for a consultation so we can assess your smile and give you an accurate quotation.",
        },
      },
      {
        "@type": "Question",
        name: "Can composite bonding repair chipped or broken teeth?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes! Composite bonding is the most cost effective solution to repairing chipped or broken teeth.",
        },
      },
    ],
  };

  const schemaData3 = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://www.compositebonding-ilkley.com/#organization",
    headline: "SmileFast Composite Bonding in Ilkley West Yorkshire",
    url: "https://www.compositebonding-ilkley.com/",
    name: "Composite Bonding ilkley",
    description:
      "Local Dentist in Kington Herefordshire - “ this part of it will be replaced with “Local Dentist in Ilkley, West Yorkshire",
    inLanguage: "en-UK",
    author: { "@id": "https://www.compositebonding-ilkley.com/#organization" },
    creator: { "@id": "https://www.compositebonding-ilkley.com/#organization" },
    publisher: {
      "@id": "https://www.compositebonding-ilkley.com/#organization",
    },
    provider: {
      "@id": "https://www.compositebonding-ilkley.com/#organization",
    },
    mentions: [
      "https://en.wikipedia.org/wiki/Dental_bonding",
      "Composite Bonding",
    ],
  };
  const schemaData4 = {
    "@context": "https://schema.org/",
    "@type": "LocalBusiness",
    name: "Composite Bonding ilkley",
    url: "https://www.compositebonding-ilkley.com/",
    sameAs: [
      "https://www.instagram.com/regentdental_ilkley/",
      "https://maps.app.goo.gl/3e3t6GKd1cvfJLHFA/",
    ],
    address: {
      "@type": "PostalAddress",
      streetAddress: "2A Regent Rd",
      addressLocality: "Ilkley",
      postalCode: "LS29 9EA",
      addressCountry: "UK",
    },
    telephone: "+44 1943 661331",
    openingHours: "Monday-Saturday 09:00-17:00",
    image: "https://www.compositebonding-ilkley.com/static/media/header-logo.d5abac7d7e76717023d1.png" 
  }    
  const schemaData5= {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Composite Bonding Ilkley",
  "description": "Transform your smile with composite bonding at Regent Dental, serving Ilkley and Keighley—expertly crafted by Dr Naeem Ashfaq to boost your natural beauty and confidence.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Composite Bonding",
    "image": "https://www.compositebonding-ilkley.com/static/media/header-logo.d5abac7d7e76717023d1.png",
    "telephone": "+44 1943 661331",
    "email": "info@example.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "2A Regent Rd",
      "addressLocality": "Ilkley",
      "addressRegion": "West Yorkshire",
      "postalCode": "LS29 9EA",
      "addressCountry": "GB"
    },
    "url": "https://www.compositebonding-ilkley.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Ilkley, GB"
  },
  "serviceType": "Composite Bonding",
  "url": "https://www.compositebonding-ilkley.com/"
}

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schemaData2)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaData3)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaData4)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaData5)}</script>
    </Helmet>
  );
};

export default SchemaComponent;
